/* global reports:true */

/**
 * Settings Object: This object creates and manipulates the DOM for settings in the View.
 * It is currently in use for admin/setting.
 */

reports = function (cui_enabled) {
	'use strict';

	var objReports = list(null, cui_enabled);
	var objDom = dom(cui_enabled);
	var objDialog = dialog();
	var objHermes = hermes();


  /***
   * Sets options and initializes participant picker for Participation Report
   ***/
  objReports.bindParticipantPicker = function() {
    var options = {
			'buttonText': 'Select Participant',
      'selectText': 'Select Participant',
			'dbData': '',
			'type': 'participation-report',
      'selectEmpty': true,
      'selectOne': true,
      'selectionRequired': true,
			'showUsers':true,
			'showRoles':true,
			'showRoleTypes':true
		};
		// Click Event for opening the participant dialog.
		$('.type-participation-report.participant-picker').participantpicker(options);
  };

	objReports.validateImpactReport = function(obj) {
		var report = $(obj).closest('.report-filter').attr('id').substring(7);

		// check for required fields first
		if	( ($('#filter-' + report + ' input[name^="report-'+report+'-prefix"]').val() !== '') &&
			($('#filter-' + report + ' input[name^="report-'+report+'-code"]').val() !== '') &&
			($('#filter-' + report + ' input[name^="catalogs"]').val() !== '')) {

			var postData = objReports.getImpactReportParameters(report);
			var reportObj = $('.open-summary[data-report-type="impact"]');

			this.ReportConfirm = new Curriculog.ReportConfirm();

            this.ReportConfirm.done(function() {
                objHermes.runImpactReport(postData);
				objReports.toggleFilters(reportObj);
				objReports.cleanupFilter(reportObj);
            });

            this.ReportConfirm.fail(function() {
            	$(obj).prop('disabled', false);
            });

		} else {

			this.ErrorDialog = new Curriculog.ImpactReportWarning();

            this.ErrorDialog.done(function() {
                $(obj).prop('disabled', false);
            });
		}
	};

	objReports.getImpactReportParameters = function (report) {

		var resourceNames = [];
		var resourcesList = [];

		$('.selected-external-systems .item').each(function(index, item) {
			var text = $(item).text();
			resourceNames.push($(item).text().trim());
			var item_dict = {};
			var itemDetails = $(item).find('input');
			var item_id = $(item).attr('id');
			item_dict['id'] = item_id.replace('item-', '');
			itemDetails.each(function() {
				var name = this.name.replace(item_id + '-', '');
				item_dict[name] = this.value;
			});
			resourcesList.push(item_dict);
		});

		var postData = {
				filters: {
					prefix: encodeURIComponent($('#filter-' + report + ' input[name^="report-'+report+'-prefix"]').val()),
					code: encodeURIComponent($('#filter-' + report + ' input[name^="report-'+report+'-code"]').val()),
					resources: resourcesList,
					resourceNames: encodeURIComponent(resourceNames.join(', ')),
					report_type: 'report'
				}
			};

		return postData;
	};

	objReports.runReport = function(postData) {

		var reportObj = $('.open-summary[data-report-type="' + postData.reportType + '"]');

		this.ReportConfirm = new Curriculog.ReportConfirm();

            this.ReportConfirm.done(function() {
              objReports.runLegacyReport(postData);
              objReports.toggleFilters(reportObj);
              objReports.cleanupFilter(reportObj);
            });

            this.ReportConfirm.fail(function() {
            	var report = $('.open-summary[data-report-type="' + postData.reportType + '"]')
						.attr('id').substring(7);
            	$('#filter-' + report + ' button[name="generate-report"]').attr('disabled', false);
        });
	};

	objReports.runLegacyReport = function(postData) {
		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			data: JSON.stringify({
				functionName: 'report_task',
				workload: {
					module_name: 'LegacyReports',
					method_name: 'generate',
					method_args: postData
				}
			}),
		});
	};

	objReports.filterReport = function(obj) {
		var report = $(obj).closest('.report-filter').attr('id').substring(7);
		var data = $('#detail-' + report).data();
		var reportType = data.reportType;
		var reportFilters = [];
		var $from, $to, $participantId, $participantType;

		// Retrieve all fields in this report filter
		reportFilters = {
			keyword: '',
			entity: '',
			entityName: '',
			processID: '',
			sort: '',
			from: '',
			to: '',
			prefix: '',
			code: '',
			status: '',
			activity: '',
			detail: '',
      participantId: '',
      participantType: ''
		};

		// Keyword
		if	( ($('#filter-' + report + ' input[name^="report-'+report+'-keyword"]').length > 0) &&
			($('#filter-' + report + ' input[name^="report-'+report+'-keyword"]').val() !== '') ) {
			reportFilters.keyword = $('#filter-' + report + ' input[name^="report-'+report+'-keyword"]').val();
		}

		// Entity
		if	( ($('#filter-' + report + ' select[name^="report-'+report+'-entity-types"]').length > 0) &&
			($('#filter-' + report + ' select[name^="report-'+report+'-entity-types"]').val() !== '') ) {
			reportFilters.entity = $('#filter-' + report + ' select[name^="report-'+report+'-entity-types"]').val();
		}

		if	($('#filter-' + report + ' select[name^="report-'+report+'-entity-types"]').length > 0)  {
			reportFilters.entityName = $('#filter-' + report + ' select[name^="report-'+report+'-entity-types"] option:selected').text().trim();
		}

		// Process ID
		if	( ($('#filter-' + report + ' select[name^="report-'+report+'-process-id"]').length > 0) &&
			($('#filter-' + report + ' select[name^="report-'+report+'-process-id"]').val() !== '')) {
			reportFilters.processID = $('#filter-' + report + ' select[name^="report-'+report+'-process-id"]').val();
		}

		// Sort (Bottleneck only)
		if	( ($('#filter-' + report + ' select[name^="report-'+report+'-sort"]').length > 0) && ($('#filter-' + report + ' select[name^="report-'+report+'-sort"]').val() !== '')) {
			reportFilters.sort = $('#filter-' + report + ' select[name^="report-'+report+'-sort"]').val();
		}

		// From/To
		if	(($('#filter-' + report + ' input[name^="report-'+report+'-from"]').length > 0) && ($('#filter-' + report + ' input[name^="report-'+report+'-from"]').val() !== '')) {
			$from = $('#filter-' + report + ' input[name^="report-'+report+'-from"]');
			$to = $('#filter-' + report + ' input[name^="report-'+report+'-to"]');
			reportFilters.from = $from.val();
			reportFilters.to = $to.val();
		}

    // Participant Type and Participant Id (Participation only)
		if	(reportType === 'participation') {
      $participantType = $('#filter-' + report + ' input[name^="report-'+report+'-participant-type"]');
			reportFilters.participantType = $participantType.val();
		  $participantId = $('#filter-' + report + ' input[name^="report-'+report+'-participant-id"]');
			reportFilters.participantId = $participantId.val();
		}

		// Status
		if ($('#filter-' + report + ' input[name^="report-'+report+'-status"]').is(':checked')) {
			var status = '';
			$('#filter-' + report + ' input[name^="report-'+report+'-status"]').each(function(index, item) {
				if ($(item).is(':checked')) {
					status += (status.length > 0) ? ',' : '';
					status += $(item).attr('id').match(/report-\d*-status-(\w*)/)[1];
				}
			});
			reportFilters.status = status;
		}

		// Activity
		if ($('#filter-' + report + ' input[name^="report-'+report+'-activity"]').is(':checked')) {
			var activity = '';
			$('#filter-' + report + ' input[name^="report-'+report+'-activity"]').each(function(index, item) {
				if ($(item).is(':checked')) {
					activity += (activity.length > 0) ? ',' : '';
					activity += $(item).attr('id').match(/report-\d*-activity-(\w*)/)[1];
				}
			});
			reportFilters.activity = activity;
		}

		// Detail
		if ($('#filter-' + report + ' input[name^="report-'+report+'-detail"]').is(':checked')) {
			var detail = '';
			$('#filter-' + report + ' input[name^="report-'+report+'-detail"]').each(function(index, item) {
				if ($(item).is(':checked')) {
					detail += (detail.length > 0) ? ',' : '';
					detail += $(item).attr('id').match(/report-\d*-detail-(\w*)/)[1];
				}
			});
			reportFilters.detail = detail;
		}

		$.validity.clear();
		$.validity.start();

		var fromDate = new Date(reportFilters.from);
		var toDate = new Date(reportFilters.to);
		var now = new Date();

		if(reportFilters.from){
			$from.match('date', 'From date must be a date formatted mm/dd/yy.')
			.assert(function() {
				if (isNaN(fromDate.getTime())) {
					return false;
				}
				return true;
			}, 'From date must be a valid date')
			.assert(function() {
				if (fromDate > now) {
					return false;
				}
				return true;
			}, 'From date can not be in the future');
		}

		if(reportFilters.to){
			$to.match('date', 'To date must be a date formatted mm/dd/yy.')
			.assert(function() {
				if (isNaN(toDate.getTime())) {
					return false;
				}
				return true;
			}, 'To date must be a valid date')
      .assert(function() {
				if (toDate > now) {
					return false;
				}
				return true;
			}, 'To date can not be in the future');
		}

		if(reportFilters.from && reportFilters.to){
			$from.assert(function() {
				if (fromDate > toDate) {
					return false;
				}
				return true;
			}, 'From date must be less than or equal to To date');
		}

    if (reportType === 'participation') {
      $participantId.assert(function(){
        if (document.getElementById($participantId.attr('id')).value) {
          return true
        }
        return false;
      }, 'Participant is Required');
    }

		var result = $.validity.end();
		if(result.errors) {
			$('button.report-'+report).prop('disabled', false);
			return result
		}


		var postData = {
			'reportType': reportType,
			'filters': reportFilters,
		};

		objReports.runReport(postData);
	};

	objReports.cleanupFilter = function(reportObj) {
		var report = $(reportObj).attr('id').substring(7);

		// Keyword
		$('#filter-' + report + ' input[name^="report-'+report+'-keyword"]').val('');

		// Entity
		$('#filter-' + report + ' select[name^="report-'+report+'-entity-types"]').prop('selectedIndex', 0);

		// Process ID
		$('#filter-' + report + ' select[name^="report-'+report+'-process-id"]').prop('selectedIndex', 0);

		// Sort (Bottleneck only)
		$('#filter-' + report + ' select[name^="report-'+report+'-sort"]').prop('selectedIndex', 0);

		// From/To
		$('#filter-' + report + ' input[name^="report-'+report+'-from"]').val('');
		$('#filter-' + report + ' input[name^="report-'+report+'-to"]').val('');

    // ParticipantId and ParticipantType (Participation Only)
		$('#filter-' + report + ' input[name^="report-'+report+'-participant-id"]').val('');
		$('#filter-' + report + ' input[name^="report-'+report+'-participant-type"]').val('');
    $('.participant-list ul').empty();
    $('.participant-list p').addClass('empty');

		// Status (reset to default: active)
		$('#filter-' + report + ' input[name^="report-'+report+'-status"]').prop('checked', false);
		$('#filter-' + report + ' input[name^="report-'+report+'-status-active"]').prop('checked', true);

		// Activity
		$('#filter-' + report + ' input[name^="report-'+report+'-activity"]').prop('checked', false);

		// Detail
		$('#filter-' + report + ' input[name^="report-'+report+'-detail"]').prop('checked', false);

		// Resource (Impact Report)
		$('#catalogs').val('');
		$('.selected-external-systems').empty();

		// prefix
		$('#filter-' + report + ' input[name^="report-'+report+'-prefix"]').val('');

		// code
		$('#filter-' + report + ' input[name^="report-'+report+'-code"]').val('');

		// submit report button
		$('#filter-' + report + ' button[name="generate-report"]').attr('disabled', false);

	};

	objReports.toggleFilters = function(report) {
		var id = $(report).attr('id').substring(7);
		var isActive = $(report).hasClass('active');

		objDom.summaryFlyout($(report), function(clicked) {
      objDom.adjustFlyout(clicked, cui_enabled);
      $('#curriculog-summary-column').focus();
    });
	};

	objReports.verticalStretchList = function() {
		objDom.verticalStretchList();
	};

	return objReports;
};
